export interface Theme {
    type: ThemeType
}

export enum ThemeType {
    default = "0",
    bootstrap_material_design = "1"
}